import {
    fetchNotificationsRequest,
    fetchNotificationsSuccess,
    fetchNotificationsFailure,
    markNotificationRead,
    markAllNotificationsRead,
    deleteNotificationAction
  } from '../reducers/notificationReducer';
  import notificationService from '../../services/notificationService';
  
  // Action creator to fetch notifications (used by navbar for badge count + preview)
  export const getNotifications = () => async (dispatch) => {
    try {
      dispatch(fetchNotificationsRequest());
      const response = await notificationService.getNotifications(false, 50, 1);
      dispatch(fetchNotificationsSuccess(response.data.notifications));
    } catch (error) {
      dispatch(fetchNotificationsFailure(
        error.response?.data?.message || 'Erreur lors de la récupération des notifications'
      ));
    }
  };
  
  // Action creator to mark a notification as read
  export const readNotification = (id) => async (dispatch) => {
    try {
      await notificationService.markAsRead(id);
      dispatch(markNotificationRead(id));
      return true;
    } catch (error) {
      console.error('Erreur lors du marquage de la notification comme lue:', error);
      return false;
    }
  };
  
  // Action creator to mark all notifications as read
  export const readAllNotifications = () => async (dispatch) => {
    try {
      await notificationService.markAllAsRead();
      dispatch(markAllNotificationsRead());
      return true;
    } catch (error) {
      console.error('Erreur lors du marquage de toutes les notifications comme lues:', error);
      return false;
    }
  };

  // Action creator to delete a notification
  export const removeNotification = (id) => async (dispatch) => {
    try {
      await notificationService.deleteNotification(id);
      dispatch(deleteNotificationAction(id));
      return true;
    } catch (error) {
      console.error('Erreur lors de la suppression de la notification:', error);
      return false;
    }
  };